import { AfterViewInit, Component, Inject, Input, ViewChild } from '@angular/core';

import { Observable, Subject } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { SubjectRelay } from '../../../shared/commands/subject-relay.class';

import { EntrepriseService } from '../services/entreprise.service';

import { EntreprisesFilters } from '../entities/entreprises-filters.entity';
import { EntrepriseTLR } from '../entities/entreprise-tlr.entity';

@Component({
	selector: 'entreprises-table',
	templateUrl: 'entreprises-table.html',
	styleUrls: ['entreprises-table.css']
})
export class EntreprisesTableComponent implements AfterViewInit {
	
	reloadEntreprises$ = new Subject<void>();
	
	private data: EntrepriseTLR[] = [];

	exportRequests$ = new Subject<void>();
	editEntrepriseRequests$ = new Subject<EntrepriseTLR| null>();
		
	isLoading: boolean = true;
	dataSource: MatTableDataSource<EntrepriseTLR> = new MatTableDataSource(this.data);
	displayedColumns: string[] = [
		'id',
		'nom',
		'adresseVille',
		'documentApplicable',
		'obsolete',
		'actions',
	];
	
	constructor(@Inject(EntrepriseService) private entrepriseService: EntrepriseService) {
		this.dataSource.filterPredicate = (entreprise: EntrepriseTLR, filterStr: string) => {
			const filters: EntreprisesFilters = JSON.parse(filterStr);

			if (this.booleanFilter(filters.actif, !entreprise.obsolete)) {
				return false;
			}
			if (this.stringFilter(filters.nom, entreprise.nom)) {
				return false;
			}
			if (this.documentApplicableFilter(filters.documentApplicable, entreprise.documentApplicable)) {
				return false;
			}
			return true;
		};

		entrepriseService.getAllEntreprises().subscribe(
			(entreprises) => {
				this.data = entreprises;
				this.dataSource.data = entreprises.filter( $ => !$.nom.startsWith('Entreprise fictive'));
				this.isLoading = false;
			}
		);

		this.filters$.subscribe(
			(filters) => {
				this.dataSource.filter = JSON.stringify(filters);
			}
		);
		
		let newExportNeeded$ = this.exportRequests$.pipe(
			withLatestFrom(this.filters$),
		);
		
		newExportNeeded$.subscribe(
			([_, filters]) => {
				// Lancer la generation et le download du excel en fonction des criteres et de l'etat choisi
				this.entrepriseService.export(filters).subscribe(
					(blob: Blob) => {
						const objectUrl: string = URL.createObjectURL(blob);
						const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
						a.href = objectUrl;
						a.download = "export-entreprises.xls";
						document.body.appendChild(a);
						a.click();
						
						document.body.removeChild(a);
						URL.revokeObjectURL(objectUrl);
					},
					(err: any) => {
						alert("Erreur lors du téléchargement de l'export");
						console.log('Could not generate the file, error: ', err);
					}
				);		
				
			}
		)
	}

	// Elements injectes necessaires a la gestion du tableau
	@ViewChild(MatPaginator) paginator!: MatPaginator;
	@ViewChild(MatSort) sort!: MatSort;

	// Liaison de l'observable alertante des changements de filtres
	private filters$ = new SubjectRelay<EntreprisesFilters>();
	@Input() set filtersSubject(obs: Observable<EntreprisesFilters> | undefined) {
		this.filters$.registerSource(obs);
	}

	ngAfterViewInit() {
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
	}
	
	// Fonctions d'aide au filtrage
	private booleanFilter = (criteria: boolean | null, value: boolean | null) => criteria !== null && value !== criteria;
	private stringFilter = (criteria: string | null, value: string | null) => criteria && (!value || value.toLowerCase().indexOf(criteria.toLowerCase()) < 0);

	private documentApplicableFilter = (criteria: string | null, docApplicableValue: string) => {
		if (criteria === null) {
			return false;
		}
		return docApplicableValue !== criteria && docApplicableValue !== 'Both';
	};
	
	delete(entreprise: EntrepriseTLR) {
		if (!confirm("Confirmez-vous la suppression de cette entreprise '" + entreprise.nom + "' ?")) {
			return;
		}

		this.entrepriseService.delete(entreprise.id).subscribe({
			next: (_result) => {
				// afficher le confirmation de suppression
				alert("L'entreprise " + entreprise.nom + " a été supprimée");
				// rafraichir l'affichage
				this.reloadList();
			},
			error: (response) => {
				if (response.status === 400 || response.status === 403) {
					alert(response.error && response.error.message ? response.error.message : 'Erreur code: ' + response.status);
				} else {
					alert("Erreur lors de la suppression de cette entreprise (erreur code: " + response.status + ")");
				}
			}
		});
	}
	
	reloadList() {
		this.isLoading = true;
		this.entrepriseService.getAllEntreprises().subscribe(
			(entreprises) => {
				this.data = entreprises;
				this.dataSource.data = entreprises;
				this.isLoading = false;
			}
		);
	}
	
}